import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const Button = styled.button`
  background-color: ${({ theme }) => theme.palette.button.primary.background};
  color: ${({ theme }) => theme.palette.button.primary.text};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 1.5rem;
  padding: 0.5rem 0.75rem;
  border: none;
  outline: none;
  transition: background-color 0.3s ease;

  &:hover {
    border-color: transparent;
    background-color: ${({ theme }) => theme.palette.primary.medium};
    cursor: pointer;
  }

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: transparent;
  }

  @media (max-width: 576px) {
    border-radius: 100%;
    padding: 0.75rem;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.palette.button.primary.text};
  width: 1rem;
  height: 1rem;

  @media (max-width: 576px) {
    width: 1.5rem;
    height: 1.5rem;
  }
`;